import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, Phone } from "lucide-react";
import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="py-24 relative overflow-hidden bg-[#1e3a52]" data-testid="cta-section">
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1524661135-423995f22d0b?q=80&w=2074&auto=format&fit=crop"
          alt="Logistique mondiale"
          className="w-full h-full object-cover opacity-10"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#152540] via-[#152540]/95 to-[#152540]" />
      </div>

      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[800px] h-64 bg-[#E8902A]/8 rounded-full blur-3xl pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-4xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="flex items-center justify-center gap-3 mb-6"
          >
            <div className="h-px w-12 bg-[#E8902A]" />
            <span className="font-heading font-bold text-xs tracking-widest uppercase text-[#E8902A]">
              Passez à l’action
            </span>
            <div className="h-px w-12 bg-[#E8902A]" />
          </motion.div>

          <motion.h2
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="font-heading font-black text-5xl md:text-6xl text-white leading-tight uppercase mb-6"
          >
            Prêts à confier vos<br />
            <span className="gradient-text">expéditions</span><br />
            à des experts ?
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="text-slate-400 text-lg leading-relaxed mb-10 max-w-xl mx-auto"
          >
            Obtenez un devis personnalisé en 24h. Notre équipe à Vichy est prête
            à étudier votre besoin et à vous proposer la solution la plus adaptée.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.3 }}
            className="flex flex-col sm:flex-row gap-4 justify-center"
          >
            <Link to="/devis" data-testid="cta-devis-btn">
              <button className="flex items-center gap-2 bg-[#E8902A] hover:bg-[#C26218] text-white font-heading font-bold text-sm tracking-widest uppercase px-8 py-4 transition-all duration-300 shadow-[0_4px_20px_rgba(232,144,42,0.4)] hover:shadow-[0_6px_28px_rgba(232,144,42,0.55)] hover:-translate-y-0.5 justify-center">
                Demander un devis gratuit
                <ArrowRight size={18} />
              </button>
            </Link>
            <Link to="/contact" data-testid="cta-contact-btn">
              <button className="flex items-center gap-2 border border-white/20 hover:border-white/40 bg-white/5 hover:bg-white/10 text-white font-heading font-bold text-sm tracking-widest uppercase px-8 py-4 transition-all duration-300 backdrop-blur-sm justify-center">
                <Phone size={18} />
                Nous contacter
              </button>
            </Link>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.5 }}
            className="flex flex-wrap items-center justify-center gap-6 mt-12 text-slate-500 text-xs font-heading uppercase tracking-widest"
          >
            <span>Réponse sous 24h</span>
            <span className="text-[#E8902A]">·</span>
            <span>Devis sans engagement</span>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
